/** Buffer percentage applied on top of the fee (incl. GST) when checking cash sufficiency. */
export const FEE_BUFFER_PCT = 0.05;
/**
 * `Scheme.region`. Region is not a currency proxy — SGAF is GLOBAL but trades in INR,
 * so read `base_currency` for currency, never this.
 */
export const SCHEME_REGION_DOMESTIC = 1;
export const SCHEME_REGION_GLOBAL = 2;
